// extracted by mini-css-extract-plugin
export default {"button":"MobMenuBurgerBtn_button__kygvR","svg":"MobMenuBurgerBtn_svg__I1Zgr"};